// Module
var code = `<div class="candidate-list-loading"> <candidates-list-item-loading ng-repeat="item in candidatesListLoadingCtrl.loadingItems"> </candidates-list-item-loading> </div>`;
// Exports
export default code;